import { NgModule } from '@angular/core';
import { MmIconModule } from '@metromarkets/components';
import { CommonModule } from '@angular/common';

import { MmExpansionComponent } from './components/mm-expansion.component';
import { MmExpansionTitleDirective } from './directives/mm-expansion-title.directive';
import { QaLocatorsModule } from '@metromarkets/sdk';

@NgModule({
  declarations: [
    MmExpansionComponent,
    MmExpansionTitleDirective,
  ],
  imports: [CommonModule, MmIconModule, QaLocatorsModule],
  exports: [
    MmExpansionComponent,
    MmExpansionTitleDirective,
  ],
})
export class MmExpansionModule {}
